import React from "react"
import SlickSlider from "react-slick"
import PropTypes from "prop-types"
import classnames from "classnames"
import FadeIn from "../components/FadeIn"

import("../styles/Slick/slick-theme.scss")
import("../styles/Slick/slick.scss")
import("../styles/slider.scss")

export default function Slider(props) {
  let slidesToShow = 3
  if (props.slides.length < 3) {
    if (props.slides.length === 2) {
      slidesToShow = 2
    } else if (props.slides.length === 1) {
      slidesToShow = 1
    } else {
      return null
    }
  }
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: props.slides.length === 1 ? 1 : 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }
  return (
    <SlickSlider
      className={classnames({ carousel: true }, props.className)}
      {...settings}
    >
      {props.slides.map((slide, index) => (
        <div key={index} className="carouselSlide">
          <FadeIn removeOnMobile={true} delay={index * 200} animation="fade">
            {slide}
          </FadeIn>
        </div>
      ))}
    </SlickSlider>
  )
}

Slider.propTypes = {
  slides: PropTypes.array.isRequired,
  className: PropTypes.string,
}
